import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const List = (
  params?: Types.IApi.List.Params,
): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/notifications', { params });

export const UnreadCount = (): AxiosPromise<Types.IApi.UnreadCount.Response> =>
  http.request.get('/api/notifications/unread-count');

export const MarkRead = (
  data: Types.IApi.MarkRead.Request,
): AxiosPromise<Types.IApi.MarkRead.Response> =>
  http.request.post('/api/notifications/mark-read', data);
